export default "__VITE_ASSET__74b7c2e9__"